import { getId } from '@thoughtspot/visualization-column-util';
import _ from 'lodash';
import { getChartType, getShowDataLabels, getVisibleSeriesIds, getVisualizedColumns, isSeriesPresentInVisibleSeries, } from '../core/chart-model-utils';
import { configOptions } from '../core/chart-type-specification-service';
import { getSeries } from '../data/data-util';
import { ChartType } from '../types';
export function isSeriesMappedToColumn(serie, columnId) {
    const isValueColumnIdentifier = serie.valueColumnIdentifier === columnId;
    const isCategoryColumnSeries = serie.categoryColumnId === columnId;
    return isValueColumnIdentifier || isCategoryColumnSeries;
}
function getChartSeriesDataLabelVisibilityState(chartModel, dataModel, toggledColumnId = undefined) {
    const series = getSeries(dataModel);
    const visualizedColumns = getVisualizedColumns(chartModel);
    const toggleSeriesIdsMap = {};
    series.forEach(serie => {
        if (!_.isNil(toggledColumnId) &&
            !isSeriesMappedToColumn(serie, toggledColumnId) &&
            chartModel.config.chartType !== ChartType.Heatmap &&
            chartModel.config.chartType !== ChartType.Treemap) {
            return;
        }
        const chartConfigOptions = configOptions(getChartType(chartModel), chartModel);
        toggleSeriesIdsMap[serie.blinkSeriesId] =
            chartConfigOptions.dataLabelsAlwaysEnabled;
        visualizedColumns.forEach(col => {
            const columnId = getId(col);
            if (isSeriesMappedToColumn(serie, columnId)) {
                let dataLabelcolumnId = columnId;
                if (chartModel.config.chartType === ChartType.Heatmap ||
                    chartModel.config.chartType === ChartType.Treemap) {
                    dataLabelcolumnId = toggledColumnId;
                }
                let showDataLabels = getShowDataLabels(chartModel, dataLabelcolumnId);
                let visibleSeriesIds = getVisibleSeriesIds(chartModel);
                if (!isSeriesPresentInVisibleSeries(chartModel, dataModel)) {
                    visibleSeriesIds = [];
                }
                showDataLabels = _.isUndefined(showDataLabels)
                    ? !!chartConfigOptions.dataLabelsEnabledByDefault
                    : showDataLabels;
                const isDataLabelVisible = (visibleSeriesIds === null || visibleSeriesIds === void 0 ? void 0 : visibleSeriesIds.length) > 0
                    ? showDataLabels &&
                        (visibleSeriesIds === null || visibleSeriesIds === void 0 ? void 0 : visibleSeriesIds.includes(serie.blinkSeriesId))
                    : showDataLabels;
                if (chartModel.config.chartType === ChartType.Heatmap ||
                    chartModel.config.chartType === ChartType.Treemap) {
                    toggleSeriesIdsMap[serie.blinkSeriesId] =
                        toggleSeriesIdsMap[serie.blinkSeriesId] &&
                            showDataLabels;
                }
                else {
                    toggleSeriesIdsMap[serie.blinkSeriesId] =
                        toggleSeriesIdsMap[serie.blinkSeriesId] ||
                            isDataLabelVisible;
                }
            }
        });
    });
    return toggleSeriesIdsMap;
}
export function updateDataLabels(chart, chartModel, dataModel, columnId = undefined, showDataLabel = true) {
    const seriesVisibilityStateMap = getChartSeriesDataLabelVisibilityState(chartModel, dataModel, columnId);
    const seriesIds = Object.keys(seriesVisibilityStateMap);
    chart.setDataLabelVisibilityBySeriesId(showDataLabel, seriesIds.filter(seriesId => seriesVisibilityStateMap[seriesId] === true));
    chart.setDataLabelVisibilityBySeriesId(false, seriesIds.filter(seriesId => seriesVisibilityStateMap[seriesId] === false));
}
//# sourceMappingURL=data-label.util.js.map